import { AttributeDetails } from "./AttributeDetails";
import { JsonSchemaDetails } from "./PromptDetails/JsonSchemaDetails";
import { ParametersDetails } from "./PromptDetails/ParametersDetails";
import { TemplateDetails } from "./PromptDetails/TemplateDetails";
import { ToolDetails } from "./PromptDetails/ToolDetails";
import { Prompt } from "@/types/app/prompt";

export const PromptVersionDetails = ({ version }: { version: Prompt }) => {
  return (
    <div>
      <ParametersDetails {...version} />
      <TemplateDetails template={version.template} template_language={version.template_language} />
      <ToolDetails tools={version.tools} />
      <JsonSchemaDetails response_format={version.response_format} />
      <AttributeDetails {...version} />
    </div>
  );
};
